<script setup lang="ts">
interface VHtmlButtonProps {
  autofocus?: boolean | undefined
  disabled?: boolean | undefined
  form?: string | undefined
  formaction?: string | undefined
  formenctype?: string | undefined
  formmethod?: string | undefined
  formnovalidate?: boolean | undefined
  formtarget?: string | undefined
  name?: string | undefined
  type?: 'submit' | 'reset' | 'button' | undefined
  value?: string | ReadonlyArray<string> | number | undefined
  role?: string | undefined
  ariaLabel?: string | undefined
}

const props = withDefaults(defineProps<VHtmlButtonProps>(), {
  type: 'button'
})

const { t, te } = useI18n()
</script>

<template>
  <button
    v-bind="{
      ...props,
      'aria-label': ariaLabel && te(ariaLabel) ? t(ariaLabel) : ariaLabel
    }"
    class="cursor-pointer"
  >
    <slot />
  </button>
</template>

<style scoped></style>
